import { ReservCell, Reservations } from 'entities/Reservations';
import { Actions } from './actions';
import {
  GET_ORDERS_BOOK_REQUEST,
  GET_ORDERS_BOOK_SUCCESS,
  GET_ORDERS_BOOK_ERROR,
  SET_MODAL_BOOK,
  CLEAN_ERROR_BOOK,
  CLEAN_BOOK_STATE,
  SET_MODAL_EDIT_BOOK,
  CREATE_CELL_REQUEST,
  CREATE_CELL_SUCCESS,
  CLEAN_IDDP,
  GET_ORDERS_OZM_REQUEST,
  GET_ORDERS_OZM_SUCCESS,
  GET_ORDERS_OZM_ERROR,
  DELETE_ORDERS_MODAL,
} from './constants';

const initialState = {
  loading: false as boolean,
  error: null as Error | null,
  bookCell: null as ReservCell | null,
  editBook: {} as Reservations,
  ordersError: null as Error | null,
  orderObject: null as string | null,
  response: {} as any,
  wrongIddp: false as boolean,
  openModal: false as boolean,
  loadingModal: false as boolean,
};

type BookingModalState = typeof initialState;

export const bookingModalReducer = (state: BookingModalState = initialState, action: Actions) => {
  switch (action.type) {
    case SET_MODAL_BOOK: {
      return {
        ...state,
        error: null,
        bookCell: action.payload,
      };
    }
    case SET_MODAL_EDIT_BOOK: {
      return {
        ...state,
        error: null,
        ordersError: null,
        editBook: action.payload,
      };
    }
    case CREATE_CELL_REQUEST: {
      return {
        ...state,
        error: null,
        loading: true,
      };
    }
    case CREATE_CELL_SUCCESS: {
      return {
        ...state,
        error: null,
        loading: false,
        bookCell: action.payload,
      };
    }
    case GET_ORDERS_BOOK_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
        ordersError: null,
        response: {},
      };
    }
    case GET_ORDERS_OZM_REQUEST: {
      return {
        ...state,
        loading: true,
        loadingModal: true,
        openModal: false,
        error: null,
        ordersError: null,
        response: {},
      };
    }
    case GET_ORDERS_OZM_SUCCESS: {
      return {
        ...state,
        loading: false,
        loadingModal: false,
        openModal: true,
        response: action.response,
      };
    }
    case GET_ORDERS_BOOK_SUCCESS: {
      return {
        ...state,
        loading: false,
        editBook: action.payload,
        response: action.response,
        wrongIddp: action.error,
      };
    }
    case DELETE_ORDERS_MODAL: {
      return {
        ...state,
        loading: false,
        editBook: action.payload,
        ordersError: null,
      };
    }
    case GET_ORDERS_OZM_ERROR: {
      return {
        ...state,
        loading: false,
        loadingModal: false,
        openModal: true,
        ordersError: action.payload,
        response: action.payload,
      };
    }
    case GET_ORDERS_BOOK_ERROR: {
      return {
        ...state,
        loading: false,
        ordersError: action.payload,
        editBook: action.bookValue,
        response: {},
      };
    }
    case CLEAN_ERROR_BOOK: {
      return {
        ...state,
        loading: false,
        ordersError: null,
        orderObject: null,
      };
    }
    case CLEAN_IDDP: {
      return {
        ...state,
        wrongIddp: false,
      };
    }
    case CLEAN_BOOK_STATE: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
};
